import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-columns',
  templateUrl: './select-columns.component.html',
  styleUrls: ['./select-columns.component.scss'],
})
export class SelectColumnsComponent implements OnInit {
  checkbox_list: any[] = [];
  maxColumns: number = 0;

  constructor(
    private dialogRef: MatDialogRef<SelectColumnsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService
  ) {
    dialogRef.disableClose = true;
    let checked = false;
    for (let i = 0; i < data.allColumns.length; i++) {
      checked = false;
      for (let j = 0; j < data.displayedColumns.length; j++) {
        if (data.allColumns[i] === data.displayedColumns[j]) {
          checked = true;
          this.checkbox_list.push({
            text: translateService.instant('tracingReports.' + data.allColumns[i]),
            name: data.allColumns[i],
            disabled: data.allColumns[i] === 'request' ? true : false,
            checked: true,
            labelPosition: 'after',
          });
          this.maxColumns++;
          break;
        }
      }
      if (checked === false) {
        this.checkbox_list.push({
          text: translateService.instant('tracingReports.' + data.allColumns[i]),
          name: data.allColumns[i],
          disabled: data.allColumns[i] === 'request' ? true : false,
          checked: false,
          labelPosition: 'after',
        });
      }
    }

    console.log(this.maxColumns);

    this.checkbox_list.sort((a, b) => {
      if (a.name == 'request' || b.name == 'request') return 0;

      let item1 = a.text.replace('% ', '').toLowerCase();
      let item2 = b.text.replace('% ', '').toLowerCase();
      if (item1 == item2) {
        return 0;
      }
      if (item1 < item2) {
        return -1;
      }
      return 1;
    });
  }

  ngOnInit(): void {}

  cancel() {
    this.dialogRef.close();
  }

  selectColumns() {
    this.dialogRef.close(this.checkbox_list);
  }

  list_change(item: any) {
    this.checkbox_list.forEach((element: any) => {
      if (element.name === item.name && item.checked) {
        element.checked = true;
        this.maxColumns++;
      } else if (element.name === item.name && !item.checked) {
        element.checked = false;
        this.maxColumns--;
      }
    });
  }
}
